var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { action, makeObservable } from 'mobx';
import { PlayStatus } from '../../../learnware/LearnwareEnums';
export class IntentActions {
    parent;
    constructor(parent) {
        makeObservable(this);
        this.parent = parent;
    }
    get intent() {
        return this.parent;
    }
    get mediaPlayer() {
        return this.intent.mediaPlayer;
    }
    abort() {
        this.intent.intentHandler.stop();
        console.log('abort intent in IntentActions', this.intent);
        this.intent.playStatus = PlayStatus.Aborted;
    }
}
__decorate([
    action.bound
], IntentActions.prototype, "abort", null);
